import React, { createContext, useContext, useState, useCallback } from 'react'
import { Box, LinearProgress, CircularProgress } from '@mui/material'

const LoadingContext = createContext(null)

export function useLoading() {
  return useContext(LoadingContext)
}

export function LoadingProvider({ children }) {
  const [dataLoading, setDataLoading] = useState(false)   // API 로딩
  const [pageLoading, setPageLoading] = useState(false)   // 페이지 이동 로딩

  const showDataLoading = useCallback(() => setDataLoading(true), [])
  const hideDataLoading = useCallback(() => setDataLoading(false), [])

  const showPageLoading = useCallback(() => setPageLoading(true), [])
  const hidePageLoading = useCallback(() => setPageLoading(false), [])

  return (
    <LoadingContext.Provider value={{
      showDataLoading, hideDataLoading,
      showPageLoading, hidePageLoading
    }}>
      {children}

      {/* 데이터 로딩: 상단 바 */}
      {dataLoading && (
        <LinearProgress sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000 }} />
      )}

      {/* 페이지 로딩: 전체 스피너 */}
      {pageLoading && (
        <Box sx={{
          position: 'fixed',
          inset: 0, 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'rgba(255,255,255,0.6)',
          zIndex: 2001
        }}>
          <CircularProgress />
        </Box>
      )}
    </LoadingContext.Provider>
  )
}
